// src/scenes/CaseManagement/SafeDocuments/index.js
import { Box } from "@mui/material";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { caseManagementUrl } from "../../../../config";
import SafeDocumentsForm from "./Form";
import { SafeDocumentsColumns } from "../../../../data/DynamicTable/Collumns";

const base_url = caseManagementUrl.uri;
const actions = {
  entity: "Safe Documents",
  isSubRight: false,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: false,
    permission: "EditPermission",
  },
  RemoveItem: {
    key: "VIEWDETAILS",
    button_name: "Remove Document",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2],
    modelName: "SafeDocuments",
    inputObjectName: "activateDeactivateSafeDocument"
  },
  add: {
    key: "Register Document(s)",
    button_name: "Register Document(s)",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },
  ViewCase: {
    key: "VIEWDETAILS",
    button_name: "View Details",
    Show_Button: false,
  },
  AssignTask: {
    key: "ASSIGN_TASK",
    button_name: "Assign Task",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2],
  },
  showStatus: true,
  dataObject: {
    inputObjectName: "safeDocumentsViewsByColumnValues",
    inputSubObjectName: "viewModel",
    returnFields: [
      "docNo",
      "registeredBy",
      "client",
      "fileNo",
      "fileName",
      "docType",
      "document",
      "givenBy",
      "returnDate",
      "approver",
      "status"
    ],
  },
};
function SafeDocuments() {
  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Documents in Safe"
          subtitle="View all Documents in Safe, register or edit "
          columns={SafeDocumentsColumns}
          FormComponent={SafeDocumentsForm}
          actions={actions}
          base_url={base_url}
        />
      </>
    </Box>
  );
}

export default SafeDocuments;